export const STATUS_PAGE_RUNTIME_CONFIG_URL = 'assets/status-page.config.json';

/** Gateway routes for the two response shapes; the boot probe and the pollers must agree on them. */
export const SYSTEM_HEALTH_STATUS_PATH = '/health-check/status';
export const SYSTEM_HEALTH_DETAIL_PATH = '/health-check/status/detail';
export const SYSTEM_HEALTH_HISTORY_PATH = '/health-check/status/history';

/**
 * Display locale, pinned rather than taken from the browser: a page read during an
 * incident must render one unambiguous date order and one set of digits for everyone.
 */
export const STATUS_PAGE_LOCALE = 'en-GB';

/** After this many consecutive failed refreshes the page slows down instead of hammering a dead API. */
export const STATUS_PAGE_FAILURES_BEFORE_BACKOFF = 3;
export const STATUS_PAGE_BACKOFF_INTERVAL_IN_SECONDS = 120;

export const STATUS_PAGE_MIN_REFRESH_INTERVAL_IN_SECONDS = 5;
export const STATUS_PAGE_MAX_REFRESH_INTERVAL_IN_SECONDS = STATUS_PAGE_BACKOFF_INTERVAL_IN_SECONDS;

/** Floor for the staleness warning; a slower cadence raises it instead of making the warning permanent. */
export const STATUS_PAGE_DATA_AGE_WARNING_FLOOR_IN_SECONDS = 120;
const DATA_AGE_REFRESH_CYCLES = 2;

export const STATUS_PAGE_COUNTDOWN_TICK_IN_MS = 1000;
/** The report covers 24 hours, so it does not need the live rows' refresh rate. */
export const STATUS_PAGE_HISTORY_INTERVAL_IN_SECONDS = 300;
/** A hanging API must read as offline, not as a frozen page: abandon a refresh after this long. */
export const STATUS_PAGE_REQUEST_TIMEOUT_IN_MS = 15_000;
/** The runtime config is a local asset; a stalled fetch must not hold the first render for 15 s. */
export const STATUS_PAGE_CONFIG_TIMEOUT_IN_MS = 3_000;

/**
 * Backing off must never poll faster than the configured cadence.
 *
 * @param refreshIntervalInSeconds - Configured refresh cadence.
 * @returns Delay to use after repeated failures, in seconds.
 */
export function backoffIntervalInSeconds(refreshIntervalInSeconds: number): number {
  return Math.max(STATUS_PAGE_BACKOFF_INTERVAL_IN_SECONDS, refreshIntervalInSeconds);
}

/**
 * Threshold above which served data is flagged as delayed.
 *
 * @param refreshIntervalInSeconds - Configured refresh cadence.
 * @returns Age after which the data is considered delayed, in seconds.
 */
export function dataAgeWarningInSeconds(refreshIntervalInSeconds: number): number {
  return Math.max(STATUS_PAGE_DATA_AGE_WARNING_FLOOR_IN_SECONDS, refreshIntervalInSeconds * DATA_AGE_REFRESH_CYCLES);
}
